import React from "react";
import { Link } from "react-router-dom";
import { Home, ArrowLeft } from "lucide-react";

export default function NotFound() {
  return (
    <section className="grid min-h-[86vh] place-items-center px-5" style={{ background: "var(--teal-950)" }}>
      <div className="text-center">
        <p className="eyebrow" style={{ color: "var(--gold-200)" }}>
          404
        </p>
        <h1 className="font-display mt-5 text-[2.4rem] sm:text-[3.2rem]" style={{ color: "#FBF7F0", fontWeight: 300 }}>
          We cannot seem to find that page
        </h1>
        <p className="mx-auto mt-5 max-w-[520px] text-[0.96rem]" style={{ color: "rgba(251,247,240,.7)" }}>
          The page may have moved. Try the campus, academics or admissions pages instead.
        </p>
        <div className="mt-10 flex flex-wrap justify-center gap-4">
          <Link
            to="/"
            className="flex items-center gap-2 rounded-full px-7 py-3.5 text-[0.86rem] font-semibold"
            style={{ background: "var(--gold)", color: "#fff" }}
          >
            <Home size={16} /> Back home
          </Link>
          <Link
            to="/admissions"
            className="flex items-center gap-2 rounded-full px-7 py-3.5 text-[0.86rem] font-semibold"
            style={{ border: "1px solid rgba(251,247,240,.35)", color: "#FBF7F0" }}
          >
            <ArrowLeft size={16} /> Admissions
          </Link>
        </div>
      </div>
    </section>
  );
}
